exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".textInputMargin___3JAME {\n  margin-top: 10px !important;\n  text-align: left;\n}\n.donateButton___2SQg7 {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/donation-box.less"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,iBAAiB;CAClB;AACD;EACE,iBAAiB;EACjB,oBAAoB;CACrB","file":"donation-box.less","sourcesContent":[".textInputMargin {\n  margin-top: 10px !important;\n  text-align: left;\n}\n.donateButton {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"textInputMargin": "textInputMargin___3JAME",
	"donateButton": "donateButton___2SQg7"
};